/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function SlidingFeed(elem) {
        Behaviors.init(SlidingFeed, this, arguments);

        this.feedItemNumber = (this.$elem.data("feed-item-number"));
        
        this.feedSlider = this.$elem.find(SlidingFeed.ELEMENTS.feedSlider).slick({
            slidesToShow: (this.feedItemNumber) + 2,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            // centerMode: true,
            centerMode: false,
            variableWidth: false,
            autoplay: false,
            infinite: true,
            prevArrow: `<button type='button' class='feed-prev pull-left'> <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.89587 1L0.937541 5.16667L4.89587 9.33333" stroke="#222141" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M0.937499 5.1665L14 5.1665" stroke="#222141" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg> </button>`,
            nextArrow: `<button type='button' class='feed-next pull-right'><svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.1041 1L14.0625 5.16667L10.1041 9.33333" stroke="#222141" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14.0625 5.1665L1 5.1665" stroke="#222141" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg></button>`,
            responsive: [
                {
                  breakpoint: 1940,
                  settings: {
                    slidesToShow: this.feedItemNumber,
                    slidesToScroll: 1,
                    infinite: true,
                  }
                },
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 3,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 2,
                        infinite: true,
                    }
                },
                {
                  breakpoint: 700,
                  settings: {
                    arrows: false,
                    dots: true,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    infinite: true,
                  }
                }
              ]
        });
        
    }
    Behaviors.inherit(SlidingFeed, Behaviors.Behavior);

    SlidingFeed.QUERY = "[data-feed-slider]";
    SlidingFeed.ELEMENTS = {
        feedSlider: ".SlidingFeed-posts_slider"
    };
    Behaviors.register_behavior(SlidingFeed);

    module.SlidingFeed = SlidingFeed;
    return module;
}(window.jQuery, window.Behaviors));